
/**
 *
 * @param {string} token JWT (Authorization)
 * @param {Object} data
 * @param {string} data.item_id                 Titre de l'œuvre
 * @param {string} data.user_id                 Genre ("Roman", "Poésie", ...)
 * @param {string} data.start_date              Langue originale de l'œuvre ("fr", "en", ...)
 * @param {string} data.end_date    
 * @param {string} data.code_etablissement    
 */
async function createLoan(API_BASE, token, data) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${token}`,
  };

  const workRes = await fetch(`${API_BASE}/loans`, {
    method: "POST",
    headers,
    body: JSON.stringify(data),
  });

  if (!workRes.ok) {
    throw new Error(await workRes.text());
  }

  const work = await workRes.json();
  //console.log("Emprunt créé avec succès:", work);

  return {
    work,
  };
}
export default createLoan;